var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCorner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 0H0C0.00279018 4.33915 0.0412946 6.66225 0.568359 8.85798C1.07227 10.957 1.90346 12.9636 3.03139 14.8041C4.30357 16.8802 6.08244 18.659 9.64033 22.2169L9.64035 22.2169L17.7831 30.3597C21.341 33.9176 23.1198 35.6964 25.1959 36.9686C27.0364 38.0965 29.043 38.9277 31.142 39.4316C33.3378 39.9587 35.6609 39.9972 40 40V0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorner);
export default __webpack_public_path__ + "static/media/corner.0c7a73b5b31c60ccd7691a176a2d48d1.svg";
export { ForwardRef as ReactComponent };